import React, { useState } from "react";
import { API } from "../lib/apiClient";
import { X } from "@phosphor-icons/react";

export default function PhotoGallery({ photos = [], thumb = "h-14 w-14", testid = "photo" }) {
  const [active, setActive] = useState(null);
  const list = (photos || []).filter((p) => p && p.id);
  if (!list.length) return null;

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {list.map((p, i) => (
          <button
            key={p.id || i}
            type="button"
            data-testid={`${testid}-thumb-${i}`}
            onClick={(e) => { e.stopPropagation(); setActive(p); }}
            className="overflow-hidden rounded-sm border border-zinc-800 transition-transform hover:scale-105 hover:border-amber-500"
          >
            <img src={`${API}/files/${p.id}`} alt="" className={`${thumb} object-cover`} loading="lazy" />
          </button>
        ))}
      </div>

      {active && (
        <div
          data-testid="photo-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[120] flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm"
        >
          <button
            type="button"
            data-testid="photo-lightbox-close"
            onClick={() => setActive(null)}
            className="absolute right-4 top-4 rounded-full bg-zinc-800/80 p-2 text-white hover:bg-rose-500"
          >
            <X size={22} weight="bold" />
          </button>
          <img
            src={`${API}/files/${active.id}`}
            alt=""
            onClick={(e) => e.stopPropagation()}
            className="max-h-[90vh] max-w-[92vw] rounded-sm object-contain shadow-2xl"
          />
        </div>
      )}
    </>
  );
}
